import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { bloodTestId: String };

  connect() {
    this.startHeartbeat();
  }

  startHeartbeat() {
    this.sendHeartbeat();
    this.heartbeatInterval = setInterval(() => {
      this.sendHeartbeat();
    }, 5000);
  }

  sendHeartbeat() {
    const csrfToken = document.querySelector('[name="csrf-token"]')?.content;

    fetch(`/blood_tests/${this.bloodTestIdValue}/user_sessions`, {
      method: "PUT",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/json",
      },
    });
  }

  disconnect() {
    clearInterval(this.heartbeatInterval);
  }
}
